import React from "react";
import styled from "styled-components";
import {ReactComponent as Logo} from "assets/images/logos/fifaLogoBlue.svg";
import {media} from "assets/css/media";

const Header = styled.header`
	position: relative;
	background-color: #ffffff;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	border-bottom: 1px solid #e4e8f0;
	z-index: 1030;
	height: 4.375rem;
	@media (max-width: ${media.mobile}) {
		height: 56px;
	}
`;

export const HeaderFifa: React.FC = () => {
	return (
		<Header>
			<a href="https://www.fifa.com/tournaments/mens/worldcup/qatar2022">
				<Logo />
			</a>
		</Header>
	);
};
